import { defineStore } from 'pinia'

export const useAlertStore = defineStore('alert', {
  state: () => ({
    messages: [],
    axiosBusy: 0
  }),

  getters: {
    axiosIsBusy: (state) => state.axiosBusy > 0
  },

  actions: {
    add(message) {
      this.messages.push(message)

      const timeout = message.type === 'error' ? 60000 : 5000
      setTimeout(() => {
        this.messages.shift()
      }, timeout)
    },

    axiosBusyInc() {
      this.axiosBusy++
    },

    axiosBusyDec() {
      this.axiosBusy--
    }
  }
})
